import S from 'common/service/sanctuary';

import {
  CLEAR,
  ADD_CRITERIA,
  REMOVE_CRITERIA,
  LOAD_CRITERIA,
  TOGGLE_EXPAND,
  ADD_CONSTRAINT,
  REMOVE_CONSTRAINT,
  CLEAR_CONSTRAINTS,
  SET_OPERATOR,
  SET_VALUE,
} from './actions';

import criteriaReducer, {
  defaultState as criteraState,
} from './criteria/reducer';

export const defaultState = {
  criteria: {},
  expanded: false,
};

export const clear = state => ({
  ...state,
  criteria: {},
});

export const updateCriteria = (state, { criteria }) => ({
  ...state,
  criteria: S.insert(
    criteria.property,
    { ...criteraState(criteria), ...criteria },
    state.criteria,
  ),
});

export const removeCriteria = (state, { criteria }) => ({
  ...state,
  criteria: S.remove(criteria.property, state.criteria),
});

export const toggleExpand = ({ expanded, ...state }) => ({
  ...state,
  expanded: S.not(expanded),
});

export const loadCriteria = (state, { criteria = [] }) => ({
  ...state,
  criteria: S.fromPairs(S.map(criterion => [
    S.prop('property', criterion),
    criterion,
  ],
  criteria)),
});

const criteriaActions = [
  ADD_CONSTRAINT,
  REMOVE_CONSTRAINT,
  CLEAR_CONSTRAINTS,
  SET_OPERATOR,
  SET_VALUE,
];

export default (state = defaultState, action) => {
  const reducer = {
    [CLEAR]: clear,
    [ADD_CRITERIA]: updateCriteria,
    [REMOVE_CRITERIA]: removeCriteria,
    [LOAD_CRITERIA]: loadCriteria,
    [TOGGLE_EXPAND]: toggleExpand,
  }[action.type];

  if (reducer) {
    return reducer(state, action);
  }

  if (action.type && S.elem(action.type, criteriaActions)) {
    const criteria = S.prop(
      S.prop('property', action.criteria),
      state.criteria,
    );

    return updateCriteria(state, {
      criteria: criteriaReducer(criteria, action),
    });
  }

  return state;
};
